<template>
  <div>
    <vs-row>
      <vs-col vs-w="6">
        <h3 style="margin-bottom: 20px">
          Reservas <small> de actividades</small>
        </h3>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col
        style="margin-bottom: 10px"
        type="flex"
        vs-justify="center"
        vs-align="center"
        vs-w="12"
      >
        <vs-table :data="reservas">
          <template slot="thead">
            <vs-th>Concepto</vs-th>
            <vs-th>Precio</vs-th>
            <vs-th>Estado</vs-th>
            <vs-th>Fecha Pago</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td
                :data="data[indextr].concepto"
                style="text-overflow: ellipsis"
                v-html="data[indextr].conceptos"
              >
              </vs-td>
              <vs-td :data="data[indextr].precio" style="width: 120px">
                {{ data[indextr].precio_total }} €
              </vs-td>
              <vs-td :data="data[indextr].estado" style="width: 255px">
                <vs-chip
                  v-if="data[indextr].estado == 0"
                  color="warning"
                  style="width: 150px"
                >
                  <span v-if="data[indextr].tpv_id === 3" style="color: white">
                    Recibo bancario
                  </span>
                  <a
                    v-else
                    :href="
                      (data[indextr].tpv_id === 2
                        ? url_tpv_pago_2
                        : url_tpv_pago_1) + data[indextr].hash
                    "
                    target="_blank"
                    style="color: white"
                  >
                    Pendiente de pago
                  </a>
                </vs-chip>
                <vs-chip v-if="data[indextr].estado == 1" color="success"
                  >Curso contratado</vs-chip
                >
                <vs-chip v-if="data[indextr].estado == 2" color="warning">
                  <a
                    :href="
                      (data[indextr].tpv_id === 2
                        ? url_tpv_pago_2
                        : url_tpv_pago_1) + data[indextr].hash
                    "
                    target="_blank"
                    style="color: white"
                  >
                    Pago por confirmar
                  </a>
                </vs-chip>
                <vs-chip v-if="data[indextr].estado == 3" color="danger"
                  >Transferencia</vs-chip
                >
                <vs-chip v-if="data[indextr].estado == -1" color="danger"
                  >Pago fallido</vs-chip
                >
                <vs-button
                  style="display: inline-block; margin-left: 5px"
                  v-if="data[indextr].estado == 0 || data[indextr].estado == 2"
                  radius
                  color="warning"
                  type="border"
                  icon-pack="feather"
                  icon="icon-refresh-cw"
                  size="small"
                  @click="estado(data[indextr].id)"
                >
                </vs-button>
                <vs-button
                  style="display: inline-block; margin-left: 5px"
                  v-if="data[indextr].estado == 0 || data[indextr].estado == 2"
                  radius
                  color="danger"
                  type="border"
                  icon-pack="feather"
                  icon="icon-x"
                  size="small"
                  @click="eliminar_reserva(data[indextr].id)"
                >
                </vs-button>
              </vs-td>
              <vs-td :data="data[indextr].created_at">
                {{ fecha_bonita(data[indextr].fechaPago) }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col vs-w="12">
        <h3 style="margin-bottom: 20px; margin-top: 20px">
          Inscripciones
          <small> a actividades periódicas o con pago fraccionado</small>
        </h3>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col
        style="margin-bottom: 10px"
        type="flex"
        vs-justify="center"
        vs-align="center"
        vs-w="12"
      >
        <!-- {{ suscripciones }} -->
        <vs-table :data="suscripciones">
          <template slot="thead">
            <vs-th>Persona</vs-th>
            <vs-th>Concepto</vs-th>
            <vs-th>Nombre actividad</vs-th>
            <vs-th>Precio</vs-th>
            <vs-th>Estado</vs-th>
            <vs-th></vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td
                :data="data[indextr].nombre"
                style="text-overflow: ellipsis"
              >
                {{ data[indextr].menor.nombre }}
                {{ data[indextr].menor.apellidos }}
              </vs-td>
              <vs-td
                :data="data[indextr].reserva_nodo.concepto"
                style="text-overflow: ellipsis"
                v-html="data[indextr].reserva_nodo.concepto"
              >
              </vs-td>
              <vs-td
                :data="data[indextr].nodo.titulo"
                style="text-overflow: ellipsis"
              >
                {{ data[indextr].nodo.titulo }}
              </vs-td>
              <vs-td
                :data="data[indextr].reserva_nodo.precio_total"
                style="width: 120px"
              >
                {{ data[indextr].reserva_nodo.precio_total }} €
              </vs-td>
              <vs-td :data="data[indextr].estado" style="width: 120px">
                <vs-chip
                  color="warning"
                  style="text-align: center"
                  v-if="
                    typeof data[indextr].reserva_nodo !== 'undefined' &&
                    typeof data[indextr].reserva_nodo.reserva !== 'undefined' &&
                    parseInt(data[indextr].reserva_nodo.reserva.estado) == 0 &&
                    parseInt(data[indextr].estado) == 1
                  "
                >
                  Pendiente de pago
                </vs-chip>
                <vs-chip
                  color="primary"
                  v-else-if="
                    typeof data[indextr].reserva_nodo !== 'undefined' &&
                    typeof data[indextr].reserva_nodo.reserva !== 'undefined' &&
                    parseInt(data[indextr].reserva_nodo.reserva.estado) == 1 &&
                    parseInt(data[indextr].estado) == 1 &&
                    data[indextr].nodo &&
                    data[indextr].nodo.deleted_at === null
                  "
                >
                  Activo
                </vs-chip>
                <vs-chip
                  color="danger"
                  v-else-if="
                    typeof data[indextr].estado === 0 ||
                    (data[indextr].nodo &&
                      data[indextr].nodo.deleted_at === null)
                  "
                >
                  Desactivado
                </vs-chip>
                <vs-chip color="danger" v-else> Inactivo </vs-chip>
              </vs-td>
              <vs-td :data="data[indextr].precio" style="width: 120px">
                <vs-button size="small" @click="showModal(data[indextr].id)">
                  Ver renovaciones
                </vs-button>
                <vs-button
                  color="danger"
                  style="margin-top: 5px"
                  error
                  :disabled="
                    data[indextr].estado === 0 ||
                    !data[indextr].nodo ||
                    data[indextr].nodo.deleted_at !== null
                  "
                  size="small"
                  @click="unsubscribeConfirm(data[indextr].id)"
                >
                  Cancelar Inscripción
                </vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <vs-popup title="Pagos" :active.sync="popUp" fullscreen>
          <vs-table :data="pagos_lines">
            <template slot="thead">
              <vs-th> Asunto </vs-th>
              <vs-th> Precio </vs-th>
              <vs-th> Fecha </vs-th>
              <vs-th> Estado </vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].asunto">
                  {{ data[indextr].asunto }}
                </vs-td>

                <vs-td :data="data[indextr].precio">
                  {{ data[indextr].precio }}€
                </vs-td>

                <vs-td :data="data[indextr].created_at">
                  {{
                    $moment(data[indextr].created_at).format("YYYY-MM-DD HH:mm")
                  }}
                </vs-td>

                <vs-td :data="data[indextr].estado">
                  <vs-chip
                    v-if="data[indextr].estado === 'Pagado'"
                    color="success"
                  >
                    Pagado
                  </vs-chip>
                  <vs-chip
                    v-if="data[indextr].estado === 'Pendiente'"
                    color="warning"
                  >
                    Pendiente
                  </vs-chip>
                  <vs-chip
                    v-if="data[indextr].estado === 'Error'"
                    color="danger"
                  >
                    Error
                  </vs-chip>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vs-popup>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
//import JQuery from 'jquery'
//let $ = JQuery

const TPV_PAYGOLD = 5;

export default {
  data() {
    return {
      reservas: [],
      inscripciones: [],
      popUp: false,
      pagos_lines: [],
    };
  },
  computed: {
    ...mapGetters([
      "url_tpv_pago",
      "url_tpv_pago_1",
      "url_tpv_pago_2",
      "suscripciones",
    ]),
  },
  mounted() {
    //Primero de todo obtenemos los hijos que tenga este gacho.
    this.$vs.loading({
      type: "default",
    });
    this.get_reservas();
    this.$store.dispatch("get_hijos");
  },
  methods: {
    unsubscribeConfirm(id) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirmar`,
        text: "¿Estás seguro que quieres cancelar la inscripción de esta actividad?",
        accept: () => {
          this.unsubscribe(id);
        },
        acceptText: "Cancelar Inscripción",
        cancelText: "¡No! Seguir con la inscripción",
      });
    },
    unsubscribe(id) {
      this.$vs.loading({
        type: "default",
      });
      this.$store
        .dispatch("unsubscribe", {
          subscription_id: id,
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    showModal(id) {
      id;
      this.pagos_lines = this.suscripciones.filter(
        (sus) => sus.id === id
      )[0].pagos;
      this.popUp = true;
      // suscripciones.filter(sus => sus.id === id)[0]
    },
    async estado(reserva_id) {
      this.$vs.loading({
        type: "default",
      });
      await this.$store.dispatch("estado", {
        reserva_id: reserva_id,
      });
      this.get_reservas();
    },
    eliminar_reserva(reserva_id) {
      this.get_reservas();
      if (confirm("¿Estás seguro que quieres eliminar esta reserva?")) {
        this.$store
          .dispatch("eliminar_reserva", {
            reserva_id: reserva_id,
          })
          .then((response) => {
            response;
            this.get_reservas();
            this.$store.getters.reservas.forEach((reserva, reserva_index) => {
              reserva_index;
              if (reserva.id == reserva_id) {
                this.$store.getters.carrito.forEach((item, index) => {
                  item;
                  index;
                  reserva.reserva_nodos.forEach((nodo, nodo_index) => {
                    nodo_index;
                    if (
                      nodo.nodo_id == item.nodo_id &&
                      nodo.menor_id == item.menor_id
                    ) {
                      this.$store.commit("quitar_reserva", index);
                    }
                  });
                });
              }
            });
          });
      }
    },
    fecha_bonita(fecha) {
      if (fecha === null) return "";
      else
        return (
          fecha.split(" ")[1] +
          " " +
          fecha.split(" ")[0].split("-").reverse().join("/")
        );
    },
    get_reservas() {
      this.$store.dispatch("get_reservas").then((data) => {
        if (typeof data !== "undefined") {
          this.reservas = data.filter((reserva) => {
            if (reserva.tpv_id !== TPV_PAYGOLD) return true;
            return false;
          });
          this.inscripciones = data.filter((reserva) => {
            if (reserva.tpv_id === TPV_PAYGOLD) return true;
            return false;
          });
        }
        this.$vs.loading.close();
      });
    },
  },
  components: {},
};
</script>
